<template>
  <div class="edit-free-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="100px"
        :label-position="labelPosition"
      >
        <el-form-item label="用户ID:" prop="uid">
          <el-input v-model.number="params.uid" size="small"></el-input>
        </el-form-item>
        <el-form-item label="发布者ID:" prop="publisherID">
          <div class="fb" v-for="(item, i) in params.publisherID" :key="i">
            <div>
              <el-input size="small" v-model.number="item.pid"></el-input>
            </div>
            <div class="fb_right">
              <el-button type="primary" icon="el-icon-delete" size="small" @click="deleteItem(i)"></el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="开始时间:" prop="startTime">
          <el-date-picker
            v-model="params.startTime"
            type="datetime"
            placeholder="请输入开始时间"
            size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间:" prop="endTime">
          <el-date-picker
            v-model="params.endTime"
            type="datetime"
            placeholder="请输入开始时间"
            size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="发布者ID操作:">
          <el-button type="primary" size="small" @click="addpublisherID({ pid: '' })">+新增发布者ID</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      flag: false,
      labelPosition: "left",
      params: {
        uid: undefined,
        publisherID: [],
        startTime: undefined,
        endTime: undefined
      },
      rules: {
        uid: [{ required: true, message: "请输入用户ID", trigger: "blur" }]
      }
    };
  },
  methods: {
    // 删除某项
    deleteItem(i) {
      this.params.publisherID.splice(i, 1);
    },
    // 新增发布者ID
    addpublisherID(obj) {
      this.params.publisherID.push(obj);
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.flag = true;
          if (this.title === "新增免费观看配置") {
            this.addfreeVid();
          } else {
            this.editfreeVid();
          }
        } else {
          return false;
        }
      });
    },
    //添加
    addfreeVid() {
      let params = Object.assign({}, this.params, {
        publisherID: this.params.publisherID.map(v => v.pid)
      });
      API.addfreeVid(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success"
            });
            this.$emit("handlerList");
          } else {
            this.$message.error("新增失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    //编辑
    editfreeVid() {
      let params = Object.assign({}, this.params, {
        publisherID: this.params.publisherID.map(v => v.pid)
      });
      API.editfreeVid(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success"
            });
            this.$emit("handlerList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        uid: undefined,
        publisherID: "",
        startTime: undefined,
        endTime: undefined
      };
      this.$refs.form.resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑免费观看配置";
        this.params.uid = data.uid;
        this.params.publisherID = data.publisherID
          .map(item => {
            let obj = {};
            obj['pid'] =item;
            return obj;
          })
        this.params.startTime = data.startTime;
        this.params.endTime = data.endTime;
      } else {
        this.title = "新增免费观看配置";
      }
    }
  }
};
</script>

<style lang="scss">
.edit-free-box {
  .el-input {
    width: 150px;
  }
  .fb {
    position: relative;
    .fb_right {
      position: absolute;
      top: -1px;
      left: 170px;
    }
  }
}
</style>
